import * as ko from "knockout";
import entityBase from "entityBase";

export class non_part_usage extends entityBase {
  npu_id: KnockoutObservable<string>;
  line_code: KnockoutObservable<string>;
  description: KnockoutObservable<string>;
  quantity: KnockoutObservable<string>;
  work_dt: KnockoutObservable<string>;
  person_id: KnockoutObservable<string>;
  user_def15: KnockoutObservable<string>; //service model
  user_def13: KnockoutObservable<string>; //service model
  user_def_dttm1: KnockoutObservable<Date>; //Starting time:
  user_def_dttm2: KnockoutObservable<Date>; //End time:

  is_new: KnockoutObservable<boolean>;

  constructor(item?: any) {
    super();
    this.npu_id = ko.observable(item?.npu_id);
    this.line_code = ko.observable(item?.line_code);
    this.description = ko.observable(item?.description);
    this.quantity = ko.observable(item?.quantity ? item?.quantity : "1");
    this.work_dt = ko.observable(item?.work_dt);
    this.person_id = ko.observable(item?.person_id);
    this.user_def15 = ko.observable(item?.user_def15);
    this.user_def13 = ko.observable(item?.user_def13);
    this.user_def_dttm1 = ko.observable(this.formatJSONDate(item?.user_def_dttm1));
    this.user_def_dttm2 = ko.observable(this.formatJSONDate(item?.user_def_dttm2));
    this.is_new = ko.observable(item?.is_new);
  }
}
